import { Play } from 'lucide-react';
import { useState } from 'react';

export interface ThumbnailProps {
  src: string;
  width: number;
  height: number;
  className?: string;
  alt?: string;
}

/** Video thumbnail with a neutral placeholder while loading or when it fails. */
export function Thumbnail({ src, width, height, className, alt = '' }: ThumbnailProps) {
  const [state, setState] = useState<{ src: string; status: 'loading' | 'loaded' | 'error' }>({ src, status: 'loading' });
  const status = state.src === src ? state.status : 'loading';
  return (
    <span className={`thumb${className ? ` ${className}` : ''} is-${status}`}>
      {status !== 'error' && (
        <img
          src={src}
          width={width}
          height={height}
          alt={alt}
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          onLoad={() => setState({ src, status: 'loaded' })}
          onError={() => setState({ src, status: 'error' })}
        />
      )}
      <Play className="thumb__placeholder" size={Math.max(16, Math.round(height / 3))} aria-hidden="true" />
    </span>
  );
}
